import { graphql } from '@/gql';
import type { CallLogsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedCallLogTypeResponse } from '@/models/callLog';

export const fetchCallLogs = async (variables: CallLogsQueryVariables): Promise<PaginatedCallLogTypeResponse> => {
  const response = await queryExecute({
    variables,
    fetchPolicy: 'no-cache',
    query: graphql(`
      query CallLogs(
        $searchType: String
        $pagination: PaginationInputType
        $phoneNumber: String
        $slackId: String
        $callerId: String
        $startDate: String
        $endDate: String
        $closingReason: String
        $direction: String
        $withRecording: Boolean
        $isGourmetInbound: Boolean
        $isGourmetOutbound: Boolean
        $isGourmetRegistration: Boolean
        $isGroceryInbound: Boolean
        $isGroceryOutbound: Boolean
        $isRegistration: Boolean
        $isNoLovedOnes: Boolean
        $isPartnerCall: Boolean
        $isSpanish: Boolean
        $isFraud: Boolean
        $isSupervisor: Boolean
        $scheduledRideId: Float
        $partnerId: Float
        $callLogId: Float
        $callSid: String
        $groceryId: Float
        $reason: String
        $purpose: String
        $hearAboutUs: String
        $isGroceryRegistration: Boolean
        $isPharmacyRegistration: Boolean
        $isHomeServicesRegistration: Boolean
        $isFacebookRegistrationInbound: Boolean
        $isFacebookRegistrationOutbound: Boolean
      ) {
        callLogs(
          searchType: $searchType
          pagination: $pagination
          phoneNumber: $phoneNumber
          slackId: $slackId
          callerId: $callerId
          startDate: $startDate
          endDate: $endDate
          closingReason: $closingReason
          direction: $direction
          withRecording: $withRecording
          isGourmetInbound: $isGourmetInbound
          isGourmetOutbound: $isGourmetOutbound
          isGourmetRegistration: $isGourmetRegistration
          isGroceryInbound: $isGroceryInbound
          isGroceryOutbound: $isGroceryOutbound
          isRegistration: $isRegistration
          isNoLovedOnes: $isNoLovedOnes
          isPartnerCall: $isPartnerCall
          isSpanish: $isSpanish
          isSupervisor: $isSupervisor
          isFraud: $isFraud
          scheduledRideId: $scheduledRideId
          partnerId: $partnerId
          callLogId: $callLogId
          callSid: $callSid
          groceryId: $groceryId
          reason: $reason
          purpose: $purpose
          hearAboutUs: $hearAboutUs
          isGroceryRegistration: $isGroceryRegistration
          isPharmacyRegistration: $isPharmacyRegistration
          isHomeServicesRegistration: $isHomeServicesRegistration
          isFacebookRegistrationInbound: $isFacebookRegistrationInbound
          isFacebookRegistrationOutbound: $isFacebookRegistrationOutbound
        ) {
          count
          rows {
            id
            callerId
            rideId
            groceryId
            gourmetId
            scheduledRideId
            operatorId
            fromPhoneNumber
            toPhoneNumber
            resolvedPhoneNumber
            callFlow
            purpose
            timeStart
            timeEnd
            waitStart
            waitEnd
            callSid
            notes
            reason
            callerName
            operatorName
            operatorRoles
            timeZone
            qualityAssurance
            hasRecording
            lovedOneId
            lovedOneName
            abTestGroups {
              groupType
              groupLabel
            }
            hearAboutUs
            callActions {
              callLogId
              userId
              userName
              userType
              action
              createdAt
            }
            operatorSlackId
            createdAt
            updatedAt
          }
        }
      }
    `),
  });

  return response.data.callLogs;
};
